import React from 'react';
import { Building2, GraduationCap, Hospital, Building, ShoppingBag, Home } from 'lucide-react';

export const IdealFor = () => {
  const useCases = [
    {
      icon: Building2,
      title: 'Oficinas y empresas',
      description: 'Espacios corporativos y de trabajo'
    },
    {
      icon: GraduationCap,
      title: 'Universidades e institutos',
      description: 'Centros educativos y campus'
    },
    {
      icon: Hospital,
      title: 'Clínicas y hospitales',
      description: 'Centros de salud y médicos'
    },
    {
      icon: Building,
      title: 'Edificios corporativos',
      description: 'Torres y complejos empresariales'
    },
    {
      icon: ShoppingBag,
      title: 'Centros comerciales',
      description: 'Áreas comerciales y retail'
    },
    {
      icon: Home,
      title: 'Condominios familiares',
      description: 'Residencias y espacios comunes'
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 bg-[#003847]/10 text-[#003847] text-sm font-semibold rounded-full mb-4">
            Casos de uso
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#003847] mb-4">
            Dónde funciona mejor BOCADIA
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Ideal para espacios donde las personas pasan tiempo y buscan comodidad
          </p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {useCases.map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-[#F8F5F0] to-white p-4 md:p-6 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                {/* Icon */}
                <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-[#003847] to-[#004555] rounded-xl flex items-center justify-center mb-3 md:mb-4 mx-auto group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <Icon className="w-6 h-6 md:w-7 md:h-7 text-white" />
                </div>

                {/* Content */}
                <div className="text-center">
                  <h3 className="text-sm md:text-base lg:text-lg font-bold text-[#003847] mb-1 md:mb-2">
                    {useCase.title}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600">
                    {useCase.description}
                  </p>
                </div>

                {/* Hover effect */}
                <div className="absolute inset-0 rounded-2xl border-2 border-[#CFAE70] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
